import './ticket.scss';
